module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/t9lUkv/images/cover.jpg?1684515369304",
      "alt": "This image is the cover for the book Amar significa… No avergonzarse, Amar significa…"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Amar significa… No avergonzarse, Amar significa…\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("Amar significa… una historia")])])]), _c('p', [_vm._v("Geoff vive en la ciudad, aprovechando la marcha gay al máximo, cuando la muerte de su padre le obliga a volver a la granja familiar. Allí conocerá a un joven Amish dormido en el establo y Geoff averiguará que el muchacho está en su Rumspringa, el año que los jóvenes Amish pasan fuera de la Comunidad antes de aceptar su bautismo en la Iglesia. A pesar de su mutua atracción, Geoff está empeñado en no liarse con él. Sin embargo Eli se ha dado cuenta que Geoff comparte sus sentimientos y comienza a cortejarle, capturando la atención de Geoff y, por supuesto, sus sentimientos.")]), _vm._v(" "), _c('p', [_vm._v("Su relación se verá amenazada por familiares de mente estrecha y los chismorreos de la sociedad en general. Un nuevo mundo se abre para Eli, que tendrá que decidir si quiere volver a la Comunidad con su familia, al mundo en el que sabe cómo será su futuro, o se quedará con Geoff y tendrá fe en el poder del amor.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Andrew Grey, Saura Garcia\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0